export default "__VITE_ASSET__fd6eccee__"